
var encode_url=0,redirect_path=0,url=0;
$(document).ready(function(){
  $('#custom-whatsapp').click(function(event){
    event.preventDefault();
    
  	encode_url=$('#encodeurl').val();
    redirect_path=$('#redirect_path').val();
    url=$(this).attr('href');
    getFile();
    
  })
	
})
function getFile()
{
 
  console.log(encode_url);
  console.log(redirect_path);
  $.ajax({
    url:"/apps/urlredirect",
    method:'POST',
    data:{ 'path':encode_url,"target":redirect_path },
    success:function(data)
    {   
     console.log(data);
      window.location.href=url;
    } 
  }) 
}
function copyPromoCode() {
      const codeText = document.getElementById("promoCode").textContent;
      navigator.clipboard.writeText(codeText).then(() => {
        const button = document.getElementById("copyBtn");
        button.textContent = "Copied!";
        button.classList.add("copied");

        // Reset after 2.5 seconds
        setTimeout(() => {
          button.textContent = "COPY";
          button.classList.remove("copied");
        }, 2500);
      });
    }
